import { useAtomValue } from 'jotai';
import React from 'react';
import {
	areStarRatingsSavedAtom,
	currentStarRatingsAtom,
	hasPhotosAtom,
	previousStarRatingsAtom,
} from '../atoms';
import { PhotoPill } from './photo-pill';
import { StarPill } from './star-pill';
import Styles from './styles.scss';

const AppliedPills = () => {
	const currentStarRatings = useAtomValue(currentStarRatingsAtom);
	const previousStarRatings = useAtomValue(previousStarRatingsAtom);
	const areStarRatingsSaved = useAtomValue(areStarRatingsSavedAtom);
	const hasPhotos = useAtomValue(hasPhotosAtom);

	return (
		<div className={Styles.container}>
			{hasPhotos && <PhotoPill />}
			{areStarRatingsSaved &&
				currentStarRatings.length > 0 &&
				currentStarRatings
					.sort()
					.reverse()
					.map((text) => <StarPill key={text} text={text} />)}
			{!areStarRatingsSaved &&
				previousStarRatings.length > 0 &&
				previousStarRatings
					.sort()
					.reverse()
					.map((text) => <StarPill key={text} text={text} />)}
		</div>
	);
};

export { AppliedPills };
